import { render, staticRenderFns } from "./r-bulk-copy-dialog.vue?vue&type=template&id=bf03d1f2"
import script from "./r-bulk-copy-dialog.vue?vue&type=script&lang=js"
export * from "./r-bulk-copy-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf03d1f2')) {
      api.createRecord('bf03d1f2', component.options)
    } else {
      api.reload('bf03d1f2', component.options)
    }
    module.hot.accept("./r-bulk-copy-dialog.vue?vue&type=template&id=bf03d1f2", function () {
      api.rerender('bf03d1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/r-bulk-copy-dialog.vue"
export default component.exports